module.exports = __webpack_public_path__ + "img/easter_island.9ea8770c.svg";